import { IAppState } from '../../redux';
import { EOfferDraftStatus } from '../../types/reducers/draft';

export function selectIsSaveDraftPending(state: IAppState): boolean {
  const {
    draft: { status },
  } = state;

  return status === EOfferDraftStatus.pending;
}
